<template>
  <div
    v-if="modalOpenState"
    class="overlay p-sm-3 d-sm-flex justify-content-center align-items-center"
    :class="{ 'p-3': !isFullMobile }"
    @click="close"
  >
    <div
      class="info p-3 shadow overflow-auto"
      :class="{ fullscreen: isFullMobile }"
      :style="size ? `max-width: ${size}px` : ''"
      @click.stop
    >
      <slot name="header" :close="() => hideModal(identifier)" class="mb-3"></slot>
      <slot name="content" :close="() => hideModal(identifier)"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Modal",
  props: {
    identifier: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: "",
    },
    initialOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeOnOutsideClick: {
      type: Boolean,
      required: false,
      default: true,
    },
    isFullMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      openModals: "getOpenModals",
    }),
    modalOpenState() {
      return this.openModals.includes(this.identifier);
    },
  },
  mounted() {
    if (this.initialOpen) this.showModal(this.identifier);
  },
  methods: {
    ...mapActions(["showModal", "hideModal"]),
    close() {
      if (this.closeOnOutsideClick) this.hideModal(this.identifier);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: $zi-highest;
  top: 0;
  left: 0;
  backdrop-filter: grayscale(0.5) opacity(0.6);
}

.info {
  width: 100%;
  background: $white;
  text-align: center;
  max-width: auto;
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: 100%;
  border-radius: $border-radius-lg;

  @media (min-width: $screen-sm-min) {
    max-width: $screen-sm-min;
  }
}

.fullscreen {
  height: 100%;

  @media (min-width: $screen-sm-min) {
    height: auto;
    max-height: 100%;
  }
}
</style>
